import { FC, useState } from 'react';
import { getConsultsForPatient } from 'api/consult/getConsultsForPatient';
import { ConsultProvider } from 'contexts/ConsultContext';
import { useQueryParams } from 'hooks/useQueryParams';

import NoShowCancellationPolicy from '../consult/eligibility/NoShowCancellationPolicy';

const NpNoShowCancellationPolicy: FC = () => {
  const { getParam } = useQueryParams();
  const memberId = getParam('memberId');
  const [consultId, setConsultId] = useState<string | undefined>(undefined);
  getConsultsForPatient(memberId).then((consults: { id: string }[]) => {
    if (consults.length > 0) {
      setConsultId(consults[0].id);
    }
  });
  if (!memberId) {
    return <div>Member ID is required</div>;
  }
  if (!consultId) {
    return <div>Consult ID is required</div>;
  }
  return (
    <ConsultProvider consultId={consultId as string}>
      <NoShowCancellationPolicy flow="np_self" />
    </ConsultProvider>
  );
};

export default NpNoShowCancellationPolicy;
